import commonUtils from "../../../utils/commonUtils";
import RingboxService from "../../../../services/RingboxService";
import { ColocatedShow, EventEditionDetails, Nullable } from "../../../types";
import CMSApiService from "../../../../services/CMSApiService";
import { EventAutocompleteOption } from "../../../../components/globalSettings/types";
import { BusinessUnit } from "../../../enums";

class EventHelper {
  private _eventLocation = "";
  private _eventEdition: Nullable<EventEditionDetails> = null;
  private _mercuryEventOptions: EventAutocompleteOption[] = [];
  private franceBuCode = BusinessUnit.FRANCE;
  private usaBuCode = BusinessUnit.US;
  private australiaBuCode = BusinessUnit.AUSTRALIA;
  private ukBuCode = BusinessUnit.UK;
  private japanBuCode = BusinessUnit.JAPAN;
  private indiaBuCode = BusinessUnit.INDIA;

  get mercuryEventOptions(): EventAutocompleteOption[] {
    return this._mercuryEventOptions;
  }

  set mercuryEventOptions(value: EventAutocompleteOption[]) {
    this._mercuryEventOptions = value;
  }

  get eventEdition(): Nullable<EventEditionDetails> {
    return this._eventEdition;
  }

  set eventEdition(value: Nullable<EventEditionDetails>) {
    this._eventEdition = value;
  }

  get eventLocation(): string {
    return this._eventLocation;
  }

  set eventLocation(value: string) {
    this._eventLocation = value;
  }

  async fetchEventEdition(eventEditionId: string): Promise<EventEditionDetails> {
    const response = await RingboxService.getEventEditionById(eventEditionId);
    return response.data.eventEdition;
  }

  async getColocatedEventEditionIds(colocatedShows: ColocatedShow[]): Promise<string[]> {
    let editions: string[] = [];
    if (colocatedShows.length !== 0) {
      editions = colocatedShows.map(cs => cs.eventEditionId);
    }
    return editions;
  }

  async getEventEditionId(getEventEditionId: () => Promise<string>) {
    let eventEditionId = process.env.REACT_APP_EVENT_EDITION_ID as string;
    try {
      if (!commonUtils.isTestEnvironment()) {
        eventEditionId = await getEventEditionId();
      }
    } catch (e) {
      console.log(e);
    }
    return eventEditionId;
  }

  async getBadgeLocation(eventEdition: EventEditionDetails) {
    const { domain } = eventEdition;
    return CMSApiService.getBadgeLocationUrl(domain);
  }

  isFranceBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.franceBuCode;
    }
    return false;
  }

  isAustraliaBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.australiaBuCode;
    }
    return false;
  }

  isUkBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.ukBuCode;
    }
    return false;
  }

  isJapanBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.japanBuCode;
    }
    return false;
  }

  isUsaBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.usaBuCode;
    }
    return false;
  }

  isIndiaBu() {
    if (this.eventEdition) {
      return this.eventEdition.businessUnitGbsCode === this.indiaBuCode;
    }
    return false;
  }
}

export default new EventHelper();
